const doc = [({"en":({"js":({"components":({"contents":({"presentation":({"index":({"error_occurred_while_generating_the_preview":"Errors occurred while generating preview"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;